
import Slider from "react-slick";

function LoginSliderComponent({...props }) {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        dir:'auto',
        rtl: true,
        arrows: false
      };

  return (
  
        <Slider className="slider-body login-slider"  {...settings}>
                                         <div className="slider-item">
                                         <img src="/static/img/login-slider-img.png" alt="img" className="img-fluid"/>

                                        </div>
                                        <div className="slider-item">
                                        <img src="/static/img/login-slider-img.png" alt="img" className="img-fluid"/>

                                        </div>
                                      
                                        <div className="slider-item">
                                        <img src="/static/img/login-slider-img.png" alt="img" className="img-fluid"/>

                                        </div>
                                        <div className="slider-item">
                                        <img src="/static/img/login-slider-img.png" alt="img" className="img-fluid"/>

                                        </div>

        </Slider>
       

  );
}

export default LoginSliderComponent;


